<template>
  <TariffNotificationModal
      ref="modalRef"
      class="pause-pro-modal"
      title="Подписка ПРО на паузе"
      button-text="Возобновить"
      secondary-button-text="Отменить"
      :max-width="450"
      @button-click="emit('resume')"
      @secondary-button-click="emit('cancel')"
      @hidden="emit('hidden')"
  >
    <template #default>
      <p v-if="feature === 'calls'" class="pause-pro-modal__text mb-0">
        Ваша подписка ПРО находится на паузе, поэтому функция «Звонки» недоступна.
        {{ pauseReturnText }}
      </p>

      <template v-else-if="feature === 'board'">
        <p class="pause-pro-modal__text mb-2">
          Ваша подписка ПРО находится на паузе, поэтому функция «Онлайн-доска» недоступна.
        </p>
        <p class="pause-pro-modal__text mb-0">
          {{ pauseReturnText }}
        </p>
      </template>

      <template v-else>
        <p class="pause-pro-modal__text mb-2">
          Во время паузы действует бесплатный тариф с ограничением до 3 учеников.
        </p>
        <p class="pause-pro-modal__text mb-0">
          {{ pauseReturnText }}
        </p>
      </template>
    </template>
  </TariffNotificationModal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import TariffNotificationModal from '../../TariffNotificationModal.vue';

type PauseFeature = 'calls' | 'board' | 'students';

const props = withDefaults(defineProps<{
    feature: PauseFeature;
    pauseReturnDeadline: string | null;
    showNavigateOnClose?: boolean;
}>(), {
    showNavigateOnClose: true,
});

const emit = defineEmits<{
    (e: 'resume'): void;
    (e: 'cancel'): void;
  (e: 'hidden'): void;
}>();

const modalRef = ref<InstanceType<typeof TariffNotificationModal> | null>(null);

const formattedDeadline = computed(() => {
    if (!props.pauseReturnDeadline) {
        return '';
    }

    const date = new Date(props.pauseReturnDeadline);
    if (Number.isNaN(date.getTime())) {
        return props.pauseReturnDeadline;
    }

    return date.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
});

  const pauseReturnText = computed(() => {
    if (!formattedDeadline.value) {
      return 'Вы можете вернуться к ПРО в любой момент и сохранить прежние условия.';
    }

    return `Вы можете вернуться к ПРО в любой момент до ${formattedDeadline.value} и сохранить прежние условия.`;
  });

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

defineExpose({
    show: showModal,
    hide: hideModal,
});
</script>

<style lang="scss" scoped>
.pause-pro-modal {
    :deep(.tariff-notification-modal__content) {
        background-color: #D7E1F5;
    }

    :deep(.tariff-notification-modal__title) {
        margin-top: 0;
        margin-bottom: 24px !important;
        font-size: 18px;
        font-weight: 800;
        line-height: 1.4;
        max-width: calc(100% - 40px);
    }

    :deep(.tariff-notification-modal__button-wrapper) {
        margin-top: 24px;
        justify-content: flex-end;
    }

    :deep(.tariff-notification-modal__button) {
        min-width: 0;
    }

    :deep(.tariff-notification-modal__button--secondary) {
        background-color: #fff;
        color: var(--bs-primary);
    }
}

.pause-pro-modal__text {
    font-size: 14px;
    margin-bottom: 0;
}
</style>